import { makeStyles } from '@material-ui/core/styles';
import { globalStyles } from 'GlobalStyles';
import { sidebarItem, sideBarWidthCollapsed } from 'UI/constants/dimensions';
import { flexAlignCenterFlexStart, flexAlignCenterJustifyCenter } from 'UI/utils/styles';

export const PADDING_MEASURES = {
  top: 6.5,
  bottom: 2.75
};

export const useSidebarStyles = makeStyles(
  theme => ({
    nav: {
      overflow: 'auto',
      overflowX: 'hidden',
      width: '100%',
      flex: 1,
      fontWeight: theme.typography.fontWeightLight,
      fontFamily: theme.typography.fontFamilyContent,
      paddingBottom: theme.spacing(2),

      '&::-webkit-scrollbar': {
        width: theme.spacing(1)
      }
    },
    accordion: {
      transition: `all ${globalStyles.transition}`,
      '&:before': {
        top: 0
      }
    },
    accordionCollapsed: {
      width: sideBarWidthCollapsed
    },
    accordionExpanded: {
      margin: '0 !important'
    },
    sectionWithItems: {
      display: 'flex',
      alignItems: 'center',
      flexGrow: 1,
      minWidth: 0
    },
    expandIcon: {
      color: theme.palette.grey[900],
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      }),
      opacity: ({ isSidebarOpen }) => (isSidebarOpen ? 1 : 0)
    },
    expandIconOpen: {
      transform: 'rotate(180deg)'
    },
    menuBox: {
      ...theme.sidebarItem,
      ...flexAlignCenterFlexStart,
      flexWrap: 'nowrap',
      backgroundColor: theme.sidebarMenu.backgroundColor,
      transition: 'all 0.5s',
      '&:hover': {
        backgroundColor: theme.palette.grey[300]
      }
    },
    lightGray: {
      backgroundColor: theme.palette.grey[200]
    },

    listItem: {
      display: 'block',
      padding: 0
    },
    menuList: {
      padding: 0
    },
    accordionDetails: {
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(0)
    },

    itemSelected: {
      color: `${theme.palette.primary.main} !important`,
      fontWeight: 700,
      '& > svg': {
        color: `${theme.palette.primary.main} !important`
      }
    },
    label: {
      marginLeft: theme.spacing(2),
      transition: `opacity ${globalStyles.transition}`
    },
    labelOpen: {
      opacity: 1
    },
    labelClose: {
      opacity: 0
    },
    labelBold: {
      fontWeight: theme.typography.fontWeightBold
    },
    popper: {
      display: ({ isSidebarOpen }) => (isSidebarOpen ? 'none' : 'block')
    },
    childrenWrapper: {
      ...flexAlignCenterJustifyCenter,
      padding: theme.spacing(PADDING_MEASURES.top, 0, PADDING_MEASURES.bottom),
      flexShrink: 0
    },
    icon: {
      color: theme.palette.grey[900]
    },
    singleItemIcon: {
      color: theme.palette.grey[600]
    },
    iconActive: {
      color: theme.palette.primary.main
    }
  }),
  { name: 'MuiAccordion' }
);

export const useStyles = makeStyles(theme => ({
  nav: {
    overflow: 'auto',
    overflowX: 'hidden',
    width: '100%',
    flex: 1,
    fontWeight: theme.typography.fontWeightLight,
    fontFamily: theme.typography.fontFamilyContent,
    paddingBottom: theme.spacing(2),

    '&::-webkit-scrollbar': {
      width: theme.spacing(1)
    }
  },
  nested: {
    padding: theme.spacing(4)
  }
}));

export const useAccordionSummaryStyles = makeStyles(
  theme => ({
    singleItem: {
      display: 'flex',
      padding: theme.spacing(0, 1.5),
      minHeight: '48px',
      '&:hover': {
        backgroundColor: theme.palette.grey[300]
      },

      transition: `padding ${globalStyles.transition}, background-color 0.5s`
    },
    singleItemCollapsed: {
      paddingLeft: sidebarItem.padding
    },
    singleItemBase: {
      paddingLeft: theme.spacing(1.5)
    },
    singleItemSubItem: {
      paddingLeft: theme.spacing(3)
    },
    accordionSummaryExpanded: {
      backgroundColor: theme.palette.grey[300],
      fontWeight: 700
    }
  }),
  { name: 'MuiAccordionSummary' }
);
